import { combineReducers } from "redux";
import { all } from "redux-saga/effects";
import { reducer as toastrReducer } from "react-redux-toastr";

import { MainStateInterface } from "scenes/MainPage/ducks";
import { MapStateInterface } from "scenes/MapPage/ducks";
import { OrthophotoPlanningStateInterface } from "scenes/OrthophotoPlanningPage/ducks";
import { AuthStateInterface } from "scenes/AuthPage/ducks";
import { ImageDetectionStateInterface } from "scenes/ImageDetectionPage/ducks";
import { ProjectReportStateInterface } from "scenes/ProjectReportPage/ducks";
import { IModalState } from "scenes/Modal/ducks";
import { UnitsManagerStateInterface } from "scenes/UnitsManager/interfaces";
import { TeamAndStaffInterface } from "scenes/TeamAndStaffPage/ducks";
import { MissionsManagerStateInterface } from "scenes/MissionsManager/interfaces";
import { LayersManagerStateInterface } from "scenes/LayersManager/interfaces";

import features from "features";

interface IReducer {
  toastr: any;
  main: MainStateInterface;
  map: MapStateInterface;
  auth: AuthStateInterface;
  orthophotoPlanning: OrthophotoPlanningStateInterface;
  imageDetection: ImageDetectionStateInterface;
  projectReport: ProjectReportStateInterface;
  teamAndStaff: TeamAndStaffInterface;
  modal: IModalState;
  unitsManager: UnitsManagerStateInterface;
  layersManager: LayersManagerStateInterface;
  missionsManager: MissionsManagerStateInterface;
}

export const rootReducers = combineReducers<IReducer>({
  toastr: toastrReducer,
  main: features.main.reducer,
  map: features.map.reducer,
  auth: features.auth.reducer,
  orthophotoPlanning: features.orthophotoPlanning.reducer,
  imageDetection: features.imageDetection.reducer,
  projectReport: features.projectReport.reducer,
  teamAndStaff: features.teamAndStaff.reducer,
  modal: features.modal.reducer,
  unitsManager: features.unitsManager.reducer,
  layersManager: features.layersManager.reducer,
  missionsManager: features.missionsManager.reducer
});

export const rootSagas = function* rootSaga() {
  yield all([
    features.auth.saga(),
    features.main.saga(),
    features.map.saga(),
    features.orthophotoPlanning.saga(),
    features.imageDetection.saga(),
    features.projectReport.saga(),
    features.teamAndStaff.saga(),
    features.unitsManager.saga(),
    features.layersManager.saga(),
    features.missionsManager.saga()
  ]);
};

export type RootStateInterface = ReturnType<typeof rootReducers>;
